/**
 * Active creater
 *
 * First dispatch a action as default
 * Then call api get data from backend,despatch second action to show data
 *
 */

import { postToTask } from 'y4/Y4Api';
import y from 'y4/Utils';
import { useContext, useState } from 'react';
import AppContext from 'context/Context';
import { chunk } from 'lodash';
import RT from 'y4/RT';

const useProduct = (loadProductsByPage = true, productPerPage = 12) => {
  const [pageChunk, setPageChunk] = useState([]);

  //Contexts
  //==================================
  const {
    config: { corp }
  } = useContext(AppContext);

  //Functions
  //==================================

  /**
   *
   * @param {*} action
   */
  const initProductList = async filter => {
    if (loadProductsByPage) {
      const rt = await loadData('TASK_ECommerce_Load_Product_List', {
        ...filter,
        start: 0,
        count: productPerPage,
        withCount: true
      });

      if (rt.isOk()) {
        return { items: rt.data.rows, itemsCount: rt.data.allCount };
      } else {
        y.toastError(rt.message);
        return { items: [], itemsCount: 0 };
      }
    } else {
      const rt = await loadData('TASK_ECommerce_Load_Product_List', {
        ...filter,
        withCount: true
      });

      if (rt.isOk()) {
        const chunks = chunk(rt.data.rows, productPerPage);
        setPageChunk(chunks);
        return { items: chunks[0], itemsCount: rt.data.allCount };
      } else {
        y.toastError(rt.message);
        return { items: [], itemsCount: 0 };
      }
    }
  };

  /**
   *
   * @param {*} action
   */
  const loadProductList = async (options, pageNo) => {
    pageNo--;
    if (pageNo < 0) pageNo = 0;
    if (loadProductsByPage) {
      const start = pageNo * productPerPage;
      const rt = await loadData('TASK_ECommerce_Load_Product_List', {
        ...options,
        start,
        count: productPerPage,
        withCount: true
      });

      if (rt.isOk()) {
        return { items: rt.data.rows };
      } else {
        y.toastError(rt.message);
        return { items: [] };
      }
    } else {
      if (pageNo >= pageChunk.length) {
        return { items: [] };
      } else {
        return { items: pageChunk[pageNo] };
      }
    }
  };

  /**
   *
   * @param {*} id
   * @returns
   */
  const loadProduct = async id => {
    const rt = await loadData('TASK_ECommerce_Load_Product_Detail', { id });
    if (rt.isOk()) {
      const rows = rt.data.rows;
      var rt1 = new RT();
      rt1.data = rows[0];
      return rt1;
    } else {
      y.toastError(rt.message);
      return rt;
    }
  };

  const loadPromo = async code => {
    return await loadData('TASK_ECommerce_Load_Promo', { code });
  };

  /**
   * Load data from back end
   * @param {*} action
   */
  const loadData = (task, params = {}) => {
    return postToTask(task, { ...params, corp });
  };

  /**
   * Return funcions
   */
  return {
    initItems: initProductList,
    loadItems: loadProductList,
    loadProduct,
    loadPromo
  };
};

export default useProduct;
